import { TableTemplate } from "components/templates/default/table/TableTemplate";
import AddModal from "./add";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import { TableColumnsType } from "antd";
import { CommonTable } from "components/atoms/table/AntdTable";
import { FirmwarePackageListResult } from "api/interfaces/settingsInterface.interface";
import Spinner from "components/atoms/loader/Spinner";
import Status, { StatusType } from "components/blocks/status/Status";
import ReleaseNote from "pages/recorders/edit/updated/modal/ReleaseNote";

export type Props = {
  isAddModal: boolean;
  isEditModal: boolean;
  onModal: (type?: string) => void;
  columns: TableColumnsType<FirmwarePackageListResult>;
  data: Array<FirmwarePackageListResult>;
  selectedRow: FirmwarePackageListResult | undefined;
  onChangePage: (page: number, totalRows: number) => void;
  paginationInfo: BasePagination;
  tablePending: boolean;
  onDownloadFile: (fileUrl: string) => void;
  onDelete?: (id: string) => void;
  isLoading: boolean;
  status: StatusType;
  onClickSearch: (keyword: string) => void;
  isViewReleaseNotesModal: boolean;
};

export default function FirmwareDWPresenter({
  isAddModal,
  isEditModal,
  onModal,
  columns,
  data,
  selectedRow,
  onChangePage,
  paginationInfo,
  tablePending,
  onDownloadFile,
  onDelete,
  isLoading,
  status,
  onClickSearch,
  isViewReleaseNotesModal,
}: Props): JSX.Element {
  return (
    <>
      <TableTemplate
        onClickBtn={() => onModal("add")}
        buttonLabel="Add Firmware Package"
        titleComponent="COVA Firmware Package"
        centerChildren={<Status status={status} />}
        onClickSearch={onClickSearch}
        data-testid="maintenance-firmware-firmware-dw-table-template-modal"
      >
        <CommonTable
          columns={columns}
          dataSource={data}
          queryInfo={paginationInfo}
          onChangePage={onChangePage}
          loading={tablePending}
          rowKey="id"
        />
      </TableTemplate>
      {isLoading && <Spinner isCenter={true} />}
      {isAddModal && (
        <AddModal
          onModal={() => onModal("add")}
          onDownloadFile={onDownloadFile}
        />
      )}

      {isEditModal && (
        <AddModal
          selectedRow={selectedRow}
          onModal={() => onModal("edit")}
          onDownloadFile={onDownloadFile}
          onDelete={onDelete}
          isLoading={isLoading}
        />
      )}

      {isViewReleaseNotesModal && (
        <ReleaseNote
          onClickCancel={() => onModal("viewReleaseNotes")}
          releaseNote={selectedRow?.releaseNote ?? null}
        />
      )}
    </>
  );
}
